(() => {
  const ui = key => document.getElementById('vt-ui-text')?.dataset[key] || key;
  const base = () => window.Shopify?.routes?.root || '/';
  let cartBusy = false;
  let cartOpening;
  function init(root = document) {
    root.querySelectorAll('.menu-drawer-container').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      const summary = menu.querySelector('summary');
      menu.addEventListener('toggle', () => summary?.setAttribute('aria-expanded', String(menu.open)));
      menu.addEventListener('keydown', event => { if(event.key === 'Escape') { menu.open = false; summary?.focus(); } });
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; }));
    });
    root.querySelectorAll('.vt-variant-select').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        document.querySelectorAll('[data-purchase-label]').forEach(button => {
          button.disabled = option.disabled;
          const label = button.querySelector('span') || button;
          label.textContent = button.dataset.purchaseLabel;
        });
        document.querySelectorAll('[data-vt-price]').forEach(el => { el.textContent = option.dataset.price; });
        document.querySelectorAll('[data-vt-compare]').forEach(el => { el.textContent = option.dataset.compare; el.hidden = !option.dataset.compare; });
        document.querySelectorAll('[data-vt-sticky] input[name="id"]').forEach(el => { el.value = option.value; });
        const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
        const slide = [...document.querySelectorAll('[data-media-id]')].find(el => el.dataset.mediaId === option.dataset.media);
        const viewport = slide?.closest('[data-vt-gallery-viewport]');
        if (viewport) viewport.scrollTo({left: slide.offsetLeft - viewport.querySelector('[data-media-id]').offsetLeft, behavior: 'smooth'});
      });
    });
    root.querySelectorAll('[data-vt-countdown]').forEach(bar => {
      if (bar.dataset.ready) return;
      bar.dataset.ready = 'true';
      const end = Date.parse(bar.dataset.deadline);
      const recurring = bar.dataset.mode === 'recurring';
      const hours = Number(bar.dataset.hours);
      const duration = (Number.isFinite(hours) && hours > 0 ? hours : 17) * 3600000;
      const anchor = Number.isFinite(end) ? end : 0;
      const update = () => {
        const now = Date.now();
        let left;
        if (recurring) {
          const elapsed = ((now - anchor) % duration + duration) % duration;
          left = Math.ceil((duration - elapsed) / 1000);
        } else {
          left = Number.isFinite(end) ? Math.max(0, Math.floor((end - now) / 1000)) : 0;
        }
        [['hh',Math.floor(left/3600)],['mm',Math.floor(left%3600/60)],['ss',left%60]].forEach(([unit,value]) => { const el=bar.querySelector('[data-vt-'+unit+']'); if(el)el.textContent=String(value).padStart(2,'0'); });
      };
      update();
      if (recurring || Number.isFinite(end)) {
        const onVisibility = () => { if (!document.hidden) update(); };
        const timer = setInterval(() => {
          if (!bar.isConnected) {
            clearInterval(timer);
            document.removeEventListener('visibilitychange', onVisibility);
            return;
          }
          update();
        }, 1000);
        document.addEventListener('visibilitychange', onVisibility);
      }
    });
    root.querySelectorAll('[data-vt-sticky]').forEach(bar => {
      if (bar.dataset.ready) return;
      bar.dataset.ready = 'true';
      const trigger = document.querySelector('.vt-buy__cta');
      if (!trigger) return;
      bar.hidden = false;
      const update = visible => {
        bar.classList.toggle('is-visible', visible);
        bar.inert = !visible;
        bar.setAttribute('aria-hidden', String(!visible));
      };
      update(false);
      const observer = new IntersectionObserver(([entry]) => update(!entry.isIntersecting), {
        rootMargin: '0px 0px -80px 0px'
      });
      observer.observe(trigger);
      const unload = event => {
        if (!event.target.contains(bar)) return;
        observer.disconnect();
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
    root.querySelectorAll('[data-vt-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const viewport = gallery.querySelector('[data-vt-gallery-viewport]');
      const thumbs = [...gallery.querySelectorAll('[data-vt-gallery-thumb]')];
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const go = index => viewport.scrollTo({left: viewport.clientWidth * index, behavior: reduced ? 'instant' : 'smooth'});
      thumbs.forEach((button, index) => button.addEventListener('click', () => go(index)));
      let frame;
      const update = () => {
        const index = Math.round(viewport.scrollLeft / viewport.clientWidth);
        thumbs.forEach((item, n) => item.setAttribute('aria-current', String(index === n)));
        gallery.querySelectorAll('video').forEach(video => { if(video.closest('.vt-gallery__slide') !== viewport.querySelectorAll('.vt-gallery__slide')[index])video.pause(); });
      };
      viewport.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame=requestAnimationFrame(update); }, {passive:true});
      viewport.addEventListener('keydown', event => {
        if (event.target !== viewport || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const index = Math.round(viewport.scrollLeft / viewport.clientWidth);
        go(Math.max(0,Math.min(thumbs.length-1,index+(event.key==='ArrowRight'?1:-1))));
      });
      update();
    });
    root.querySelectorAll('form[action$="/cart/add"]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        if (cartBusy || button.disabled) return;
        cartBusy = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        const previousAlert = form.querySelector('[role="alert"]');
        if(previousAlert) previousAlert.hidden = true;
        try {
          if (window.VT_PREVIEW) {
            const cart = JSON.parse(localStorage.getItem('vt-preview-cart') || '[]');
            const id = new FormData(form).get('id');
            const product = window.VT_PREVIEW.products.find(p => p.variants.some(v => String(v.id) === String(id)));
            if (!product) throw new Error('Product unavailable');
            const line = cart.find(item => item.id === id);
            if (line) line.quantity += 1;
            else cart.push({ id, title: product.title, price: Number(product.variants[0].price), image: product.images[0]?.local || '', quantity: 1 });
            localStorage.setItem('vt-preview-cart', JSON.stringify(cart));
            openPreviewCart();
          } else {
            const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || 'Unable to add this item.');
            try { await openNativeCart(); } catch { window.location.assign(base()+'cart'); }
          }
        } catch (error) {
          let status = form.querySelector('[role="alert"]');
          if (!status) { status = document.createElement('p'); status.setAttribute('role', 'alert'); form.append(status); }
          status.hidden = false; status.textContent = error.message || ui('addError');
        } finally { cartBusy = false; button.disabled = false; button.removeAttribute('aria-busy'); }
      });
    });
    root.querySelectorAll('a[href$="/cart"]').forEach(link => {
      if(link.dataset.cartReady) return;
      link.dataset.cartReady='true';
      link.addEventListener('click', async event => { event.preventDefault(); if(window.VT_PREVIEW)openPreviewCart();else { try { await openNativeCart(); } catch { window.location.assign(link.href); } } });
    });
  }
  function openNativeCart() {
    if(cartOpening) return cartOpening;
    cartOpening = loadCart().finally(() => { cartOpening = null; });
    return cartOpening;
  }
  const cartSection = () => document.getElementById('ft-cart-template')?.dataset.sectionId || 'fortion-cart';
  async function loadCart() {
    const response = await fetch(base()+'?section_id='+encodeURIComponent(cartSection()), {cache:'no-store'});
    if(!response.ok) throw new Error(ui('cartError'));
    renderCart(await response.text(), true);
  }
  function renderCart(html, show) {
    const template = new DOMParser().parseFromString(html, 'text/html').querySelector('#ft-cart-template');
    if(!template) throw new Error(ui('cartError'));
    let dialog = document.querySelector('.vt-cart-dialog');
    if(!dialog) {
      dialog=document.createElement('dialog'); dialog.className='vt-cart-dialog ft-cart-dialog';
      dialog.setAttribute('aria-label', ui('cart')); document.body.append(dialog);
      dialog.addEventListener('close', () => {
        document.body.classList.remove('vt-cart-open');
        dialog.returnFocus?.focus({preventScroll:true});
        if(location.pathname.replace(/\/$/,'')===base()+'cart')location.reload();
      });
      dialog.addEventListener('click', event => {
        if(event.target === dialog) {
          const r=dialog.getBoundingClientRect();
          if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom) dialog.close();
        }
      });
    }
    const scrollTop=dialog.querySelector('.vt-cart-items')?.scrollTop||0;
    dialog.replaceChildren(template.content.cloneNode(true));
    dialog.querySelectorAll('[data-cart-close]').forEach(button=>button.onclick=()=>dialog.close());
    const notice=dialog.querySelector('[data-cart-status]');
    const bubble=document.getElementById('cart-icon-bubble');
    const count=Number(template.dataset.itemCount)||0;
    if(bubble) {
      let badge=bubble.querySelector('[data-cart-count]');
      if(!badge) {badge=document.createElement('span');badge.className='vt-cart-count';badge.dataset.cartCount='';bubble.append(badge);}
      badge.textContent=count;badge.hidden=!count;bubble.setAttribute('aria-label',ui('cart')+' ('+count+')');
    }
    dialog.querySelectorAll('[data-cart-key]').forEach(row=> {
      const quantity=row.querySelector('[data-cart-quantity]');
      const current=Number(row.dataset.quantity);
      const change=async (value, control)=> {
        if(dialog.getAttribute('aria-busy')==='true') return;
        dialog.setAttribute('aria-busy','true');
        dialog.querySelectorAll('input,button:not(.vt-dialog-close)').forEach(el=>el.disabled=true);
        notice.textContent=ui('loading');
        let changed=false;
        try {
          const result=await fetch(base()+'cart/change.js',{
            method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
            body:JSON.stringify({id:row.dataset.cartKey,quantity:value,sections:[cartSection()],sections_url:base()})
          });
          const updated=await result.json();
          if(!result.ok)throw new Error(updated.description||ui('cartError'));
          changed=true;
          const section=updated.sections?.[cartSection()];
          if(section)renderCart(section,false);
          else await loadCart();
          if(dialog.open) {
            const updatedRow=[...dialog.querySelectorAll('[data-cart-key]')].find(el=>el.dataset.cartKey===row.dataset.cartKey);
            (updatedRow?.querySelector(control)||dialog.querySelector('.vt-dialog-close'))?.focus({preventScroll:true});
          }
        } catch(error) {
          if(changed) {window.location.assign(base()+'cart');return;}
          notice.textContent=error.message;notice.setAttribute('role','alert');quantity.value=current;
          dialog.querySelectorAll('input,button').forEach(el=>el.disabled=false);
        } finally {dialog.removeAttribute('aria-busy');}
      };
      quantity.onchange=()=>change(Math.max(0,Math.floor(Number(quantity.value)||0)),'[data-cart-quantity]');
      row.querySelector('[data-cart-minus]').onclick=()=>change(Math.max(0,current-1),'[data-cart-minus]');
      row.querySelector('[data-cart-plus]').onclick=()=>change(current+1,'[data-cart-plus]');
      row.querySelector('[data-cart-remove]').onclick=()=>change(0,'.vt-dialog-close');
    });
    if(dialog.querySelector('.vt-cart-items'))dialog.querySelector('.vt-cart-items').scrollTop=scrollTop;
    if(show&&!dialog.open) {
      dialog.returnFocus=document.activeElement;
      dialog.showModal();document.body.classList.add('vt-cart-open');
    }
  }
  function openPreviewCart() {
    let dialog = document.querySelector('.vt-cart-dialog');
    if (!dialog) { dialog = document.createElement('dialog'); dialog.className = 'vt-cart-dialog'; document.body.append(dialog); }
    const cart = JSON.parse(localStorage.getItem('vt-preview-cart') || '[]');
    dialog.replaceChildren();
    const close = document.createElement('button'); close.className = 'vt-dialog-close'; close.textContent = '×'; close.setAttribute('aria-label', 'Close cart'); close.onclick = () => dialog.close(); dialog.append(close);
    const title = document.createElement('h2'); title.textContent = 'Your cart'; dialog.append(title);
    cart.forEach((item, index) => {
      const row = document.createElement('div'); row.className = 'vt-cart-preview-item';
      const image = document.createElement('img'); image.src = item.image; image.alt = item.title; row.append(image);
      const label = document.createElement('div'); label.textContent = `${item.title} — $${(item.price * item.quantity).toFixed(2)}`; row.append(label);
      const quantity = document.createElement('input'); quantity.type = 'number'; quantity.min = '1'; quantity.max = '99'; quantity.value = item.quantity; quantity.setAttribute('aria-label', 'Quantity');
      quantity.onchange = () => { cart[index].quantity = Math.max(1, Math.min(99, Number(quantity.value) || 1)); localStorage.setItem('vt-preview-cart', JSON.stringify(cart)); openPreviewCart(); }; row.append(quantity);
      const remove = document.createElement('button'); remove.textContent = 'Remove'; remove.onclick = () => { cart.splice(index, 1); localStorage.setItem('vt-preview-cart', JSON.stringify(cart)); openPreviewCart(); }; row.append(remove); dialog.append(row);
    });
    const total = document.createElement('p'); total.textContent = cart.length ? `Subtotal: $${cart.reduce((sum, item) => sum + item.quantity * item.price, 0).toFixed(2)}` : 'Your cart is empty'; dialog.append(total);
    const note = document.createElement('p'); note.className = 'vt-note'; note.textContent = 'Prévia local. O pagamento será realizado pelo checkout da sua loja Shopify após a instalação.'; dialog.append(note);
    if (!dialog.open) dialog.showModal();
  }
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
